import { partnerBillingAddressSchema } from "Partner/Components/Form/Schema/partnerBillingAddressSchema";
import { checkVAT, countries } from "jsvat";
import { z } from "zod";

export const getPartnerBillingProfileSchema = () => {
	const isVatIdValid = (vatId: string) => {
		if (!vatId) {
			return true;
		}

		const result = checkVAT(vatId, countries);

		return result.isValidFormat;
	};

	return z.object({
		invoicingName: z
			.string()
			.trim()
			.min(4, "Invoicing name must be at least 4 characters"),
		vatId: z
			.string()
			.refine((val) => isVatIdValid(val), {
				message: "VAT ID has invalid format",
			})
			.optional()
			.nullable(),
		vatLiable: z.boolean().nullish(),
		businessId: z.string().nullish(),
		type: z.string(),
		birthCountry: z.string().nullish(),
		birthCity: z.string().nullish(),
		birthDate: z.string().nullish(),
		tin: z.string().nullish(),
		address: partnerBillingAddressSchema().nullish(),
	});
};

export type PartnerBillingProfileFormModel = z.infer<
	ReturnType<typeof getPartnerBillingProfileSchema>
>;
